import AnchorLink from '@/components/AnchorLink';

const BASE =
  'inline-flex items-center justify-center gap-2 px-7 py-4 text-sm font-semibold tracking-wide transition-colors duration-200 active:translate-y-px';

const VARIANTS = {
  primary: 'bg-brand text-white hover:bg-brand-dark',
  light: 'bg-white text-ink hover:bg-sand',
  outlineLight: 'border border-white/60 text-white hover:bg-white hover:text-ink',
  outlineDark: 'border border-ink text-ink hover:bg-ink hover:text-white',
};

export default function Button({ href, variant = 'primary', className = '', children, ...props }) {
  const classes = `${BASE} ${VARIANTS[variant]} ${className}`;

  if (href?.startsWith('#')) {
    return (
      <AnchorLink href={href} className={classes} {...props}>
        {children}
      </AnchorLink>
    );
  }

  if (!href) {
    return (
      <button type="button" className={classes} {...props}>
        {children}
      </button>
    );
  }

  const external = href?.startsWith('http');
  return (
    <a
      href={href}
      className={classes}
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      {...props}
    >
      {children}
    </a>
  );
}
